module.exports = __webpack_public_path__ + "media/customizations/viridian/chat-bubble-bd8f0c05d42b3cd03c20b84b9b03318e.png";